import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  IMPORTER_VALIDATION,
} from '@app/Seller/Importer/accessTokens'

const ImporterBase = () => import('@app/Seller/Components/Base')
const ImporterValidation = () => import('@app/Seller/Importer/Validation')
const ImporterList = () => import('@app/Seller/Importer/List')
const ImporterProducts = () => import('@app/Seller/Importer/Products')
const ImporterInfo = () => import('@app/Seller/Importer/Info')
const ImporterEdit = () => import('@app/Seller/Importer/Edit')

const MODEL = 'importer'

const BASE = `${MODEL}/`
// const u = url => BASE + url

const LIST = 'list/'
// const INFO = 'info/'
const VALIDATION = 'validation/'
const INFO = 'info/'
const PRODUCTS = 'products/'
const EDIT = ':id/edit/'

export const IMPORTER_PREFIX = `${MODEL}:`
const p = name => IMPORTER_PREFIX + name

export const IMPORTER_BASE_NAME = p('base')
export const IMPORTER_LIST_NAME = p('list')
export const IMPORTER_PRODUCTS_NAME = p('products')
export const IMPORTER_VALIDATION_NAME = p('validation')
export const IMPORTER_IMPORT_NAME = p('import')
export const IMPORTER_INFO_NAME = p('info')
export const IMPORTER_EDIT_NAME = p('edit')

export function createRoutes(options) {
  return [
    route(BASE, ImporterBase, IMPORTER_BASE_NAME, {
      meta: accessPermission(IMPORTER_VALIDATION, options),
      redirect: { name: IMPORTER_LIST_NAME },
      children: [
        // route(LIST, ImporterList, IMPORTER_LIST_NAME, {
        //   meta: accessPermission(IMPORTER_VALIDATION, options),
        // }),
        route(INFO, ImporterInfo, IMPORTER_INFO_NAME, {
          meta: accessPermission(IMPORTER_VALIDATION, options),
        }),
        route(LIST, ImporterList, IMPORTER_LIST_NAME, {
          meta: accessPermission(IMPORTER_VALIDATION, options),
        }),
        route(VALIDATION, ImporterValidation, IMPORTER_VALIDATION_NAME, {
          meta: accessPermission(IMPORTER_VALIDATION, options),
        }),
        route(PRODUCTS, ImporterProducts, IMPORTER_PRODUCTS_NAME, {
          meta: { ...accessPermission(IMPORTER_VALIDATION, options) },
        }),
        route(EDIT, ImporterEdit, IMPORTER_EDIT_NAME, {
          meta: { ...accessPermission(IMPORTER_VALIDATION, options), needKey: true },
        }),
      ],
    }),
  ]
}
